const INVITATION_EXPIRED = 'TB11';
const INVITATION_NOTFOUND = 'TB10';
const BOARD_NOT_FOUND = 'TB1';
const BOARD_ERROR_CODES = [INVITATION_EXPIRED, INVITATION_NOTFOUND, BOARD_NOT_FOUND];

const codeIsError = (code) => {
    return code === INVITATION_EXPIRED || code === INVITATION_NOTFOUND || code === BOARD_NOT_FOUND;
};

module.exports = {codeIsError, INVITATION_EXPIRED, INVITATION_NOTFOUND, BOARD_NOT_FOUND, BOARD_ERROR_CODES};



// WEBPACK FOOTER //
// ./src/server/plugins/tripboard-invitations/constants.js